"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("card/base"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireDefault(require("react"));

var _class, _descriptor, _descriptor2;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PageLinkCard = (_class = /*#__PURE__*/function (_Card) {
  babelHelpers.inherits(PageLinkCard, _Card);

  var _super = _createSuper(PageLinkCard);

  function PageLinkCard() {
    var _this;

    babelHelpers.classCallCheck(this, PageLinkCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this, "customCard", _descriptor, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "customCardBody", _descriptor2, babelHelpers.assertThisInitialized(_this));
    return _this;
  }

  babelHelpers.createClass(PageLinkCard, [{
    key: "renderTileContainer",
    value: function renderTileContainer() {
      if (this.customCard) return /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content",
        dangerouslySetInnerHTML: {
          __html: this.customCardBody
        }
      });
      return babelHelpers.get(babelHelpers.getPrototypeOf(PageLinkCard.prototype), "renderTileContainer", this).call(this);
    }
  }]);
  return PageLinkCard;
}(_base.default), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "customCard", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "customCardBody", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = PageLinkCard;